import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { BRAND } from "@/data/site";
import { StoreButtons } from "@/components/site/StoreButtons";

export const Footer = () => {
  return (
    <footer className="relative bg-charcoal border-t border-zinc-800 pt-24 md:pt-32 pb-12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-20">
          <div className="lg:col-span-6">
            <p className="font-display font-black text-6xl md:text-8xl text-white" style={{ letterSpacing: "0.01em" }}>
              Re<span className="text-ember">Bar</span>OS
            </p>
            <p className="font-cond font-bold text-xl md:text-2xl uppercase tracking-wide text-ember mt-4">
              Built Under Load.
            </p>
            <p className="font-body text-zinc-400 mt-4 max-w-md">
              Train like it's your job. Eat like it matters.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Explore</p>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="font-body text-zinc-300 hover:text-ember transition-colors">Features</a>
              </li>
              <li>
                <a href="#pricing" className="font-body text-zinc-300 hover:text-ember transition-colors">Pricing</a>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy" className="font-body text-zinc-300 hover:text-ember transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-link-terms" className="font-body text-zinc-300 hover:text-ember transition-colors">Terms of Service</Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Contact</p>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email"
              className="group inline-flex items-center gap-2 font-body text-zinc-300 hover:text-ember transition-colors"
            >
              <Mail size={16} />
              {BRAND.email}
            </a>
            <StoreButtons className="mt-8" stacked />
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-zinc-800">
          <p className="font-body text-sm text-zinc-500" data-testid="footer-copyright">
            © 2026 ReBarOS. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="font-body text-sm text-zinc-500 hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="font-body text-sm text-zinc-500 hover:text-white transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
